export default __webpack_public_path__ + "static/media/omni-logo.b8a1d42c.svg";